export const ProjectType = {
  PROJECTCOUNT: "PROJECTCOUNT",
};
